module.exports = __webpack_public_path__ + "static/img/banner4.a1bb69c3.png";